module.exports = __webpack_public_path__ + "static/media/team-chris.83058a56.jpg";